export default "__VITE_ASSET__BxqPoQI1__"